import React, {useEffect, useState} from "react";
import Navbar from "./Navbar";
import report from "../assets/report-icon.png";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { hasQuestions } from "../Utils/reportGenerator";
import { useDispatch, useSelector } from "react-redux";
import { allDataThunk, allData } from "../redux/allDataSlice";
import MustHavePurchase from "../Utils/MustHavePurchase";

const Reports = () => {
  const dispatch = useDispatch();
  const [reportList, setReportList] = useState([]);
  const allDataChanged = useSelector((state) => state.allData.changed);
  const allDataLoaded = useSelector((state) => state.allData.loaded);

  useEffect(() => {
    dispatch(allDataThunk());
  }, []);

  useEffect(()=>{
    if (!allDataLoaded) {
      return;
    }

    const hasDrink = hasQuestions(allData, ["drink1"]);

    const allReports = [
      {name: "Allergy Report", url: "/guest/allergy-report", qs:[]},
      {name: "Assistance Report", url: "/guest/assistance-report", qs:[]},
      {name: "Attendance Report", url: "/guest/all-events-attendance-report", qs:[]},
      {name: "Drinks Report", url: "/guest/drinks-report", qs:["drink1"]},
      {name: "Expected Report", url: "/guest/expected-report", qs:[]},
      {name: "External Hotel Stay Report", url: "/guest/external-hotel-stay-report", qs:["transfer"]},
      {name: "Flights Report", url: "/guest/flights-report", qs:["flightArrival"]},
      {name: (hasDrink) ? "Food and Drink Report" : "Food Report" , url: "/guest/food-and-drink-report", qs:[]},
      {name: "Food Report", url: "/guest/food-report", qs:["drink1"]}, // only show food only report when its different from food and drink
      {name: "Guest of", url: "/guest/guest-of-report", qs:[]},
      {name: "Hotel Extension Dates Report", url: "/guest/hotel-extension-dates-report", qs:["extendStay"]},
      {name: "Mehndi Report", url: "/guest/mehndi-report", qs:["mehndi"]},
      {name: "Songs Report", url: "/guest/songs-report", qs:["song"]},
      {name: "Traditional Styling Report", url: "/guest/traditional-styling-report", qs:["saree"]},
      {name: "Unable to Attend Report", url: "/guest/unable-to-attend-report", qs:[]},
      {name: "Wedding Venue Stay Report", url: "/guest/wedding-venue-stay-report", qs:["extendStay"]},
    ];

    if (Array.isArray(allData?.reports?.reports)) {
      for (var idx=0; idx<allData.reports.reports.length; idx++) {
        var report = allData.reports.reports[idx];
        if (!report.dashboard) {
          console.log(report);
          allReports.push({name:report.name, url:"/guest/custom-report/"+idx, qs:[]});
        }
      }
    }
    allReports.sort((a,b)=>a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
    const availableReports = allReports.filter(r=>r.qs.length===0 || hasQuestions(allData, r.qs));

    setReportList(availableReports);

  }, [allDataChanged]);


  return (
    <>
      <MustHavePurchase/>
      <Helmet>
        <meta charSet="utf-8" />
        <meta
          name="description"
          content="Select and download all RSVP reports with your Guest RSVP details to share with all your suppliers to help you with planning and budgeting for all your Wedding Ceremonies."
        />
        <link
          rel="canonical"
          href="https://shiv-worldwide.com/guest/reports"
        ></link>
        <title>Wedding Invitations &amp; RSVP Platform</title>
      </Helmet>
      <div>
        <Navbar />
        <div className="container card-b-1">
          <div className="row">
            <h6 className="col-md-12 welcome-text">
              <h4 className="heading">Report</h4>
              Welcome to your reporting page. Here you will find reports for all the RSVP questions you have selected that you can view and download into excel to help you work with your suppliers as well as plan and budget for every one of your events.
              <br></br> <br></br>
              <div className="refer">
                <a href="/video-guides" target="_blank">Online video guides</a><br/><br/>
              </div>
            </h6>
          </div>

          <div className="container bg-w">
            <div className="row report-main-box">
              {reportList.map(r =>
                <div className="col-sm-12 col-md-4 col-lg-3 ">
                  <Link to={r.url}>
                    <div className="report-box-in">
                      <div className="report-text">
                          {" "+r.name+" "}
                      </div>
                      <div className="report-icon">
                          {" "}
                          <img
                            className="report-icon-1"
                            src={report}
                            alt="report"
                          />
                      </div>
                    </div>
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Reports;
